module.exports = __webpack_public_path__ + "static/img/1.28368569.svg";